import { Injectable, OnDestroy } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { BehaviorSubject } from 'rxjs';
import { GetRealtimeValueChangeScanner } from 'src/app/shared/functions/common-functions';
import { LiteProjectRealtimeData } from 'src/app/shared/interfaces/DrawoutLite/LiteRealTimeAPIInterfaces';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LiteProjectRealtimeService implements OnDestroy {

    public otherData: any;
    currentProjectId: string = null

    private liteProjectChangeObservable = new BehaviorSubject<LiteProjectRealtimeData | null>(null);
    private hubConnection: signalR.HubConnection;

    constructor() { }

    public get ProjectDataChanges() {
        return this.liteProjectChangeObservable.pipe(GetRealtimeValueChangeScanner<LiteProjectRealtimeData>());
    }

    public get CurrentProjectData() {
        return this.liteProjectChangeObservable.value;
    }

    public startConnection = () => {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${environment.realTimeAPIRoot}/litehub`)
            .withAutomaticReconnect()
            .build();

        return this.hubConnection.start();
    }

    public updateRealtimeProjectData(data: LiteProjectRealtimeData) {
        this.liteProjectChangeObservable.next(data);
    }

    // Lite Project
    public listenLiteProjectHub = (projectId, organisationCode) => {
        this.currentProjectId = projectId;
        this.hubConnection.on(`transferliteproject-${projectId}-${organisationCode}`, (data) => {
            if (data.liteProjectId === this.currentProjectId) {
                this.liteProjectChangeObservable.next(data);
            }
        });
    }

    public broadCastToHub = (projectId, organisationCode) => {
        this.hubConnection.invoke(`transferliteproject-${projectId}-${organisationCode}`, this.otherData)
            .catch(err => console.error(err));
    }

    public listenHubBrodcasts = (projectId, organisationCode) => {
        this.hubConnection.on(`bcliteproject-${projectId}-${organisationCode}`, (data) => {
            this.otherData = data;
        })
    }

    public stopConnection() {
        this.hubConnection.stop()
    }

    ngOnDestroy(): void {
        this.stopConnection();
    }
}